import { render, staticRenderFns } from "./CalculatorComponent.vue?vue&type=template&id=6bcb20d2&scoped=true"
import script from "./CalculatorComponent.vue?vue&type=script&lang=js"
export * from "./CalculatorComponent.vue?vue&type=script&lang=js"
import style0 from "./CalculatorComponent.vue?vue&type=style&index=0&id=6bcb20d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcb20d2",
  null
  
)

export default component.exports